import { useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
import style from './style.module.less';
import { useOpenRuleDrawer } from '../../../automation-rules/hooks/use-open-rule-drawer';

export const AutomationRuleLink = ({ automationRules = [] }) => {
  const intl = useIntl();
  const [isExpanded, setIsExpanded] = useState(false);
  const onExpansionChange = useCallback(() => setIsExpanded(!isExpanded), [isExpanded]);
  const openRuleDrawer = useOpenRuleDrawer();

  const onRuleSelected = useCallback(
    (automationRule) => {
      openRuleDrawer({ rule: automationRule, name: automationRule.name });
      setIsExpanded(false);
    },
    [openRuleDrawer],
  );
  const icon = isExpanded ? faCaretUp : faCaretDown;

  return (
    <FlexColumn className={style['rule-links']}>
      <FlexRow>
        <Text
          formattedMessageValues={{ ruleCount: automationRules.length }}
          textType={TextType.Label}
          value={messages.automationRuleLabelText}
        />
        {automationRules.length > 1 && (
          <Button ariaLabel={intl.formatMessage(messages.automationRuleExpanderAriaLabel)} onClick={onExpansionChange}>
            <FontAwesomeIcon className={style.icon} icon={icon} />
          </Button>
        )}
      </FlexRow>
      {automationRules.length === 1 && (
        <Button onClick={() => onRuleSelected(automationRules[0])} theme='link'>
          {automationRules[0].name}
        </Button>
      )}
      {isExpanded ? (
        <FlexColumn className={style['rule-list']}>
          {automationRules.map((rule) => (
            <Button key={rule.automationRuleId} className={style['rule-item']} onClick={() => onRuleSelected(rule)} theme='link'>
              {rule.name}
            </Button>
          ))}
        </FlexColumn>
      ) : null}
    </FlexColumn>
  );
};
